module.exports = __webpack_public_path__ + "img/64200.34cc4998.jpg";